import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getRoleType(id, filter) {
	const {data} = await axios.get(`/misc/role-type`, {params: filter});

	return data;
}

export function useRoleType() {
	const [filter, filterRelations] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [relationId, relationById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["roleTypes", relationId, filter], async () => getRoleType(relationId, filter));

	return {data, isLoading, isError, error, filter, filterRelations, relationById};
}
